/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLockDown = createReactComponent("lock-down", "IconLockDown", [
  [
    "path",
    {
      d: "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.015",
      key: "svg-0"
    }
  ],
  ["path", { d: "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-1" }],
  ["path", { d: "M8 11v-4a4 4 0 1 1 8 0v4", key: "svg-2" }],
  ["path", { d: "M19 16v6", key: "svg-3" }],
  ["path", { d: "M22 19l-3 3l-3 -3", key: "svg-4" }]
]);

export { IconLockDown as default };
//# sourceMappingURL=IconLockDown.js.map
